// Add project specific javascript code and import of additional bundles here:

import {
  fieldRegistry,
  textEditorRegistry,
  listFieldTransformerRegistry
} from "sulu-admin-bundle/containers";
import TextEditorInline from "./fields/TextEditorInline";
import TextEditorParagraphs from "./fields/TextEditorParagraphs";
import RoleAutocomplete from "./fields/RoleAutocomplete";
import CKEditor5Inline from "./adapters/ckeditor5_inline";
import CKEditor5Paragraphs from "./adapters/ckeditor5_paragraphs";
import TranslatableStringTransformer from "./transformers/TranslatableStringTransformer";
import TranslatableMultipleStringTransformer from "./transformers/TranslatableMultipleStringTransformer";

fieldRegistry.add('text_editor_inline', TextEditorInline);
fieldRegistry.add('text_editor_paragraphs', TextEditorParagraphs);
fieldRegistry.add('role_autocomplete', RoleAutocomplete);

textEditorRegistry.add('ckeditor5_inline', CKEditor5Inline);
textEditorRegistry.add('ckeditor5_paragraphs', CKEditor5Paragraphs);

listFieldTransformerRegistry.add('translatable_string', new TranslatableStringTransformer());
listFieldTransformerRegistry.add('translatable_multiple_string', new TranslatableMultipleStringTransformer());
